<div class="banner">
  <span class="material-icons" mat-dialog-close>cancel</span>
  <a [routerLink]="['/', 'plan']" mat-dialog-close>
    <img
      src="/assets/images/banner/price-down.png"
      alt="プレリリース記念キャンペーン"
    />
  </a>
</div>
